import React from "react";
import "./ExamPlanReviews.scss";

const REVIEW_STEP_LABELS = ["개념완성", "약점격파", "집중강화", "문법공략", "약점공략", "최종암기", "최종암기"];

const maskStudentName = (studentName) => {
    if (!studentName) return "";
    if (studentName.length === 1) return "*";
    return `${studentName[0]}${"*".repeat(Math.max(1, studentName.length - 2))}${studentName.slice(-1)}`;
};

export default function ExamPlanReviews({ reviews }) {
    const reviewItems = reviews.map((review, index) => ({
        ...review,
        missionNumber: Math.min(index + 1, 6),
        avatarNumber: index + 1,
        stepLabel: REVIEW_STEP_LABELS[index] || "",
        maskedName: maskStudentName(review.studentName),
    }));
    const recentReviews = reviewItems.slice().reverse();
    const tickerReviews = recentReviews.concat(recentReviews);

    return (
        <section className="schlr-rvws">
            <div className="schlr-rvws__hall">
                <div className="schlr-rvws__hall-cont">
                    <div className="schlr-rvws__trophy" />
                    <p className="schlr-rvws__hall-desc">
                        전 과목 평균 95점 이상
                        <br />
                        성적 우수 장학생들의 후기로 검증된
                    </p>
                    <p className="schlr-rvws__hall-desc">
                        스마트올 중학
                        <br />
                        최적의 시험대비 학습 루틴!
                    </p>
                </div>
                <div className="schlr-rvws__ticker">
                    <div className="schlr-rvws__ticker-track">
                        {tickerReviews.map((review, index) => (
                            <span className="schlr-rvws__ticker-chip" key={`${review.studentName}-${index}`}>
                                <span className="schlr-rvws__ticker-name">{review.maskedName}</span>
                                <span className="schlr-rvws__ticker-detail">
                                    ({review.school} {review.grade}, 평균 {review.averageScore ?? "--"}점)
                                </span>
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            <div className="schlr-rvws__grid">
                {reviewItems.map((review) => (
                    <article className="schlr-rvws__card" key={`${review.studentName}-${review.examPeriod}`}>
                        <div className="schlr-rvws__card-cont">
                            <div className="schlr-rvws__card-head">
                                <div className="schlr-rvws__hdg">
                                    <span className="schlr-rvws__tag">
                                        STEP {review.missionNumber} · {review.stepLabel}
                                    </span>
                                    <h2 className="schlr-rvws__tit">{review.mission}</h2>
                                </div>
                            </div>
                            <div className="schlr-rvws__review">
                                <p
                                    className="schlr-rvws__body"
                                    dangerouslySetInnerHTML={{
                                        __html: formatSubtitle(review.review),
                                    }}
                                ></p>
                            </div>
                        </div>
                        <div>
                            <div className={`schlr-rvws__avatar schlr-rvws__avatar--${review.avatarNumber}`} />
                            <div className="schlr-rvws__name">
                                {review.maskedName}({review.grade})
                                <br />
                                평균 {review.averageScore ?? "00"}점
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

function formatSubtitle(subtitle = "") {
    return subtitle.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\n/g, "<br>");
}
